import logo from "../assets/img/logo.png";

export default function Header() {
  return (
    <header className="header glass-container .glass-container--rounded glass-container--large" id="header">
      <nav className="nav container">
        <a href="#" className="nav__logo">
          <img src={logo} alt="Topgun Logo" />
        </a>

        <div className="nav__menu" id="nav-menu">
          <ul className="nav__list">
            <li className="nav__item">
              <a href="#home" className="nav__link active-link">
                Home
              </a>
            </li>
            <li className="nav__item">
              <a href="#specs" className="nav__link">
                Features
              </a>
            </li>
            <li className="nav__item">
              <a href="#how-it-works" className="nav__link">
                How It Works
              </a>
            </li>
            <li className="nav__item">
              <a href="#products" className="nav__link">
                Screenshots
              </a>
            </li>
             <li className="nav__item">
              <a href="#Download" className="nav__link">
                Download
              </a>
            </li>
          </ul>

          <div className="nav__close" id="nav-close">
            <i className="ri-close-line" />
          </div>
        </div>

        <div className="nav__toggle" id="nav-toggle">
          <i className="ri-function-line" />
        </div>
      </nav>
    </header>
  );
}
